<template>
  <div>
    <div>
      <v-alert v-model="alertBerhasil" type="success" dense dismissible>
        {{ alertMassage }}
      </v-alert>
      <v-alert v-model="alertGagal" type="error" dense dismissible>
        {{ alertMassage }}
      </v-alert>
    </div>

    <div>
      <v-data-table
        :headers="headers"
        :items="rwkursuss"
        :mobile-breakpoint="0"
        :loading="ldata"
        hide-default-footer
      >
        <template v-slot:top>
          <rwkursusModalEdit />
          <rwkursusModalHapus />
        </template>
        <template v-slot:[`item.nomorpenyelenggara`]="{ item }">
          <div class="py-1">
            {{ item.noSertipikat }} <br />
            {{ item.tanggalKursus }} <br />
            {{ item.institusiPenyelenggara }}
          </div>
        </template>
        <template v-slot:[`item.tempatpelaksanaan`]="{ item }">
          {{ item.tempat }} <br />
          {{ item.pelaksanaan.awal }} S/d {{ item.pelaksanaan.akhir }} <br />
          {{ item.pelaksanaan.jp }} Jam
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon small class="mr-1" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import Cookie from "@/helper/cookie.js";
import Auth from "@/helper/auth.js";

import rwkursusModalEdit from "@/components/asn/profil/rwkursus/ModalEdit";
import rwkursusModalHapus from "@/components/asn/profil/rwkursus/ModalHapus";

import modal_editState from "@/store/asn/rwkursus/modal_edit";
import modal_hapusState from "@/store/asn/rwkursus/modal_hapus";
import refreshView from "@/store/asn/rwkursus/viewRwkursus";

export default {
  name: "rwkursus",

  components: {
    rwkursusModalEdit,
    rwkursusModalHapus,
  },

  computed: {
    refresh: {
      get() {
        return refreshView.state.Refresh;
      },
    },

    alertMassage: {
      get() {
        return refreshView.state.alertMassage;
      },
    },

    success: {
      get() {
        return refreshView.state.success;
      },

      set(value) {
        refreshView.commit("alert", value);
      },
    },

    alertBerhasil: {
      get() {
        return refreshView.state.alertBerhasil;
      },

      set(value) {
        refreshView.commit("berhasilAlert", value);
      },
    },

    alertGagal: {
      get() {
        return refreshView.state.alertGagal;
      },

      set(value) {
        refreshView.commit("gagalAlert", value);
      },
    },
  },

  watch: {
    refresh() {
      this.getData();
      setTimeout(() => {
        this.alertGagal = false;
        this.alertBerhasil = false;
      }, 5000);
    },
  },

  data: () => ({
    token: Cookie.get("token"),
    get_nip: "",

    ldata: true,

    rwkursuss: [],
    rwkursus: {},

    //Kebutuhan Edit
    editedIndex: -1,
    hapusIndex: -1,

    headers: [
      { text: "Nama Pelatihan Teknis", align: "start", value: "namaKursus" },
      {
        text: "Nomor dan Tanggal Pelatihan Penyelenggara",
        value: "nomorpenyelenggara",
        sortable: false,
      },
      {
        text: "Tempat / Tanggal Pelaksanaan Jumlah Jam",
        value: "tempatpelaksanaan",
        sortable: false,
      },
      {
        text: "Actions",
        value: "actions",
        align: "center",
        width: "80px",
        sortable: false,
      },
    ],
  }),

  async mounted() {
    this.get_nip = this.$route.params.id;
    this.getData();
  },

  methods: {
    getData() {
      this.ldata = true;
      const url = process.env.VUE_APP_ASN + "kursus/nip/" + this.get_nip;

      this.http
        .get(url, {
          headers: {
            Authorization: "Bearer " + this.token,
          },
        })
        .then((response) => {
          this.ldata = false;
          refreshView.commit("refreshData", false);
          this.rwkursuss = response.data.mapData.RwKursus;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            Auth.logout(this.token);
          } else if (error.response) {
            console.log(error.response.status);
          } else {
            console.log("Error", error.message);
          }
        });
    },

    editItem(item) {
      this.editedIndex = this.rwkursuss.indexOf(item);
      this.rwkursus = Object.assign({}, item);
      modal_editState.commit("toggleModal", true);
      modal_editState.commit("editModal", Object.assign({}, item));
    },

    deleteItem(item) {
      this.hapusIndex = this.rwkursuss.indexOf(item);
      this.rwkursus = Object.assign({}, item);
      modal_hapusState.commit("toggleModal", true);
      modal_hapusState.commit("hapusModal", Object.assign({}, item));
    },
  },
};
</script>
